(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["otul-stopy-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('su-insoles-reviews')) {
    customElements.define('su-insoles-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.track = this.querySelector('[data-reviews-track]');
        this.cards = Array.from(this.track.querySelectorAll('.review'));
        this.labels = JSON.parse(this.querySelector('[data-reviews-labels]').textContent);
        this.toggle = this.querySelector('[data-reviews-toggle]');
        this.progress = this.querySelector('[data-reviews-progress]');
        this.previous = this.querySelector('[data-reviews-prev]');
        this.next = this.querySelector('[data-reviews-next]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.hovered = this.matches(':hover');
        this.focused = this.contains(document.activeElement);
        this.inViewport = false;
        this.timer = null;
        this.scrollFrame = null;
        this.focusFrame = null;
        this.lastProgress = '';
        this.previous.addEventListener('click', () => { this.pauseAfterInteraction(); this.move(-1); }, { signal });
        this.next.addEventListener('click', () => { this.pauseAfterInteraction(); this.move(1); }, { signal });
        this.toggle.addEventListener('click', () => {
          if (this.reducedMotion.matches) return;
          this.paused = !this.paused;
          this.updateControls();
          this.schedule();
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', () => {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = requestAnimationFrame(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
        }, { signal });
        ['pointerdown', 'touchstart', 'wheel'].forEach(eventName => {
          this.track.addEventListener(eventName, () => this.pauseAfterInteraction(), { signal, passive: true });
        });
        this.track.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) this.pauseAfterInteraction();
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateControls());
        }, { signal, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => { this.updateControls(); this.schedule(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => { this.updateControls(); this.schedule(); });
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          this.schedule();
        }, { threshold: [0, 0.25] });
        this.intersectionObserver.observe(this);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.cleanup();
        }, { signal });
        this.updateControls();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      cleanup() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.focusFrame);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
        this.timer = null;
      }

      stride() {
        const card = this.cards[0];
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 1;
      }

      canSlide() {
        return this.track.scrollWidth > this.track.clientWidth + 2;
      }

      pauseAfterInteraction() {
        this.paused = true;
        this.progress.setAttribute('aria-live', 'polite');
        this.updateControls();
        this.schedule();
      }

      updateControls() {
        if (!this.abortController) return;
        const canSlide = this.canSlide();
        this.previous.disabled = !canSlide;
        this.next.disabled = !canSlide;
        this.toggle.disabled = this.reducedMotion.matches || !canSlide;
        this.toggle.textContent = this.reducedMotion.matches ? this.labels.reduced : (this.paused ? this.labels.play : this.labels.pause);
        this.toggle.setAttribute('aria-pressed', String(this.paused || this.reducedMotion.matches));
        const first = Math.min(this.cards.length, Math.max(1, Math.round(this.track.scrollLeft / this.stride()) + 1));
        const visible = Math.max(1, Math.round(this.track.clientWidth / this.stride()));
        const last = Math.min(this.cards.length, first + visible - 1);
        const message = this.labels.progress.replace('__FIRST__', first).replace('__LAST__', last).replace('__TOTAL__', this.cards.length);
        if (message !== this.lastProgress) {
          this.progress.textContent = message;
          this.lastProgress = message;
        }
      }

      move(direction, automated = false) {
        if (!this.canSlide()) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = this.track.scrollLeft;
        let left;
        if (direction > 0 && current >= maximum - 3) left = 0;
        else if (direction < 0 && current <= 3) left = maximum;
        else left = Math.max(0, Math.min(maximum, (Math.round(current / this.stride()) + direction) * this.stride()));
        this.progress.setAttribute('aria-live', automated ? 'off' : 'polite');
        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.abortController || this.paused || this.hovered || this.focused || !this.inViewport || document.hidden || this.reducedMotion.matches || !this.canSlide()) return;
        this.timer = setTimeout(() => {
          this.move(1, true);
          this.schedule();
        }, 15000);
      }
    });
  }

  if (!customElements.get('su-insoles-product')) {
    customElements.define('su-insoles-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.canPurchase = this.dataset.purchaseEnabled === 'true';
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-variant-id]');
        this.buyButton = this.querySelector('[data-buy-button]');
        this.image = this.querySelector('.su-insoles__image');
        this.currentColor = null;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-option-index]')) this.updateVariant();
        });
        this.addEventListener('click', event => {
          const direction = event.target.closest('[data-gallery-direction]');
          if (direction) {
            const thumbnails = Array.from(this.querySelectorAll('[data-image-src]'));
            const current = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
            const index = (current + Number(direction.dataset.galleryDirection) + thumbnails.length) % thumbnails.length;
            if (thumbnails[index]) thumbnails[index].click();
            return;
          }
          const dialog = this.querySelector('[data-image-dialog]');
          if (event.target.closest('[data-enlarge]') && this.image) {
            const enlarged = dialog.querySelector('img');
            enlarged.src = this.image.src;
            enlarged.alt = this.image.alt;
            dialog.showModal();
            return;
          }
          if (event.target.closest('[data-dialog-close]')) {
            dialog.close();
            return;
          }
          const thumbnail = event.target.closest('[data-image-src]');
          if (!thumbnail) return;
          this.setImage(thumbnail.dataset.imageSrc, thumbnail.dataset.imageAlt);
          this.querySelectorAll('[data-image-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
        });
        this.form.addEventListener('submit', event => {
          const variant = this.getVariant(this.getOptions());
          if (!this.canPurchase || !variant || !variant.available) event.preventDefault();
        });
        this.querySelector('[data-image-dialog]').addEventListener('click', event => {
          if (event.target === event.currentTarget) event.currentTarget.close();
        });
        this.updateVariant(false);
      }

      getOptions() {
        return [0, 1, 2].map(index => {
          const fields = this.querySelectorAll('[data-option-index="' + index + '"]');
          const field = Array.from(fields).find(input => input.tagName === 'SELECT' || input.checked);
          return field ? field.value : '';
        });
      }

      getVariant(options) {
        return this.variants.find(variant => variant.options.every((value, index) => value === options[index]));
      }

      updateVariant(updateUrl = true) {
        const options = this.getOptions();
        const variant = this.getVariant(options);
        this.querySelectorAll('[data-pack-price]').forEach(price => {
          const packVariant = this.getVariant([price.dataset.packPrice, options[1], options[2]]);
          price.textContent = packVariant ? packVariant.price : '—';
        });
        this.querySelectorAll('[data-pack-unit-price]').forEach(price => {
          const packVariant = this.getVariant([price.dataset.packUnitPrice, options[1], options[2]]);
          price.textContent = packVariant ? packVariant.unit_price : '—';
        });
        this.idInput.value = variant ? variant.id : '';
        this.idInput.disabled = !variant;
        const purchasable = Boolean(this.canPurchase && variant && variant.available);
        this.buyButton.disabled = !purchasable;
        this.buyButton.textContent = purchasable ? this.labels.add : (this.canPurchase ? this.labels.unavailable : this.labels.soon);
        this.querySelector('[data-availability]').textContent = purchasable ? this.labels.available : (this.canPurchase ? this.labels.unavailable : this.labels.soon);
        this.querySelector('[data-current-price]').textContent = variant ? variant.price : '—';
        if (variant && variant.image && this.currentColor !== options[1]) this.setImage(variant.image, variant.image_alt);
        this.currentColor = options[1];
        if (variant && updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      setImage(source, alt) {
        if (!this.image || !source) return;
        this.image.removeAttribute('srcset');
        this.image.src = source;
        this.image.alt = alt || '';
        const path = new URL(source, window.location.href).pathname;
        this.querySelectorAll('[data-image-src]').forEach(button => {
          const thumbnailPath = new URL(button.dataset.imageSrc, window.location.href).pathname;
          button.setAttribute('aria-pressed', String(path === thumbnailPath));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
